import { useState } from 'react';
import { Box, Divider, IconButtonProps, ListItemIcon, Menu, MenuItem, Stack } from '@mui/material';
import { ReactComponent as MoreIcon } from '../../assets/PepWise2.0/more-vertical-black.svg';
import { useTheme } from '@mui/material/styles';

type MenuItemType = {
  key: string;
  label: string;
  icon?: JSX.Element;
  onMenuClick: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
};

export type MoreOptionMenuProps = {
  menuItems: MenuItemType[];
  icon?: JSX.Element;
} & IconButtonProps;

const WidgetMoreActionMenu: React.FC<MoreOptionMenuProps> = ({ menuItems, icon, ...props }) => {
  const theme = useTheme();
  const colors = theme.palette;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Stack sx={{ cursor: 'pointer' }} onClick={handleOpen}>
        {icon || <MoreIcon />}
      </Stack>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              '& .MuiMenu-list': {
                paddingTop: 0,
                paddingBottom: 0,
              },
            },
          },
        }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: `${colors.moreOptionDropdown?.background} !important`,
            color: `${colors.moreOptionDropdown?.menuItemText} !important`,
            borderRadius: '6px',
            boxShadow: `
            -2px 0 6px rgba(0, 0, 0, 0.2),   /* left */
            2px 0 6px rgba(0, 0, 0, 0.2),   /* right */
            0 4px 8px rgba(0, 0, 0, 0.25)   /* bottom */
            `,
            minWidth: 160,
          },
        }}
      >
        {menuItems.map(({ key, label, icon, onMenuClick, disabled }, index) => (
          <>
            <MenuItem
              key={key}
              disabled={disabled}
              onClick={(event) => {
                onMenuClick(event);
                handleClose();
              }}
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                color:
                  key === 'delete'
                    ? `${colors.moreOptionDropdown?.deleteMenuItem} !important`
                    : `${colors.moreOptionDropdown?.menuItemText} !important`,
                minHeight: '48px !important',
                py: 0,
                display: 'flex',
                alignItems: 'center',
                '&:hover': {
                  backgroundColor: `${colors.moreOptionDropdown?.menuItemHover} !important`,
                },
              }}
            >
              {icon && (
                <ListItemIcon
                  sx={{
                    minWidth: 32,
                  }}
                >
                  {icon}
                </ListItemIcon>
              )}

              <Box component="span">{label}</Box>
            </MenuItem>
            {index < menuItems.length - 1 && (
              <Divider
                sx={{ margin: '0 !important', backgroundColor: `${colors.widget.text.noChange}` }}
              />
            )}
          </>
        ))}
      </Menu>
    </>
  );
};

export default WidgetMoreActionMenu;
